import styled from "styled-components";
const MAX_HEIGHT_OFFSET = 250;

export const Styles = styled.div`
  transition: 0.1s;
  &.close {
    display: none;
  }
  .filter-wrapper {
    padding: 10px;
    border: 1px solid;
    width: 260px;
    max-height: calc(100vh - ${MAX_HEIGHT_OFFSET}px);
    overflow-y: auto;

    .ant-form-item {
      margin: 0 0 15px;
    }

    .title {
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 10px;
    }

    .sort {
      .ant-radio-group {
        display: flex;
        flex-direction: column;
      }
    }

    .filter {
      border-top: 1px solid #ccc;
      p.title {
        margin-top: 10px;
      }
      .filter-options {
        height: 330px;
        overflow-y: auto;
        .filter_special_empty {
          margin: 0px;
          .ant-form-item-control-input {
            min-height: 18px;
          }
        }
        .ant-checkbox-wrapper {
          width: 100%;
          span:nth-of-type(2) {
            width: 100%;
            white-space: nowrap;
          }
        }

        &::-webkit-scrollbar {
          width: 10px;
          height: 10px;
        }

        &::-webkit-scrollbar-track {
          background: #f1f1f1;
        }

        &::-webkit-scrollbar-thumb {
          background: #888;
        }

        &::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
      }
    }

    .action {
      display: flex;
      flex-direction: row;
      gap: 5px;

      p {
        font-size: 14px;
        font-weight: 500;
        text-decoration: underline;
        color: #0989ff;
        cursor: pointer;
      }

      span {
        color: #0989ff;
      }
    }

    .footer {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-top: 20px;
      gap: 10px;

      .btn {
        width: 120px;
        min-width: fit-content;

        &-cancel {
          background: #ffffff;
          border: 1px solid #174a83;
          color: #174a83;
        }
      }
    }
  }
`;
